<template>
  <div class="search-field-container" :class="{ 'mobile fill-width': $vuetify.display.mobile }">
    <text-field
      ref="input"
      :model-value="modelValue"
      :readonly="isPlaceholder"
      variant="solo"
      color-mode="top-bar"
      spellcheck="false"
      :placeholder="placeholderText || $translate('SearchField.search')"
      class="search-field"
      :class="{ 'v-input--is-focused': forceFocus }"
      @update:model-value="$emit('update:model-value', $event)"
      @focus="onFocus"
      @blur="onBlur"
    >
      <template #prepend-inner>
        <i-custom-menu-search class="search-icon" />
      </template>
      <template #append-inner>
        <the-button v-if="!disableClose && modelValue" custom-colors icon small class="color-top-bar-tint" @click="onClose">
          <i-custom-close-circle-filled />
        </the-button>
      </template>
    </text-field>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: null
    },
    isPlaceholder: {
      type: Boolean,
      default: false
    },
    disableClose: {
      type: Boolean,
      default: false
    },
    forceFocus: {
      type: Boolean,
      default: false
    },
    placeholderText: {
      type: String,
      default: null
    }
  },
  emits: ["update:model-value", "focus", "close"],
  data() {
    return {
      focused: false
    }
  },
  activated() {
    this.focus()
  },
  mounted() {
    this.focus()
  },
  methods: {
    async focus() {
      if (this.isPlaceholder) {
        return
      }

      await this.$nextTick()
      //For older iOS devices timeout is required
      setTimeout(() => {
        if (this.$refs.input) {
          this.$refs.input.focus()
        }
      }, 500)
    },
    onFocus() {
      if (this.isPlaceholder) {
        return
      }
      this.focused = true
      this.$emit("focus")
    },
    onBlur() {
      if (!this.forceFocus) {
        this.focused = false
      }
    },
    onClose() {
      this.focused = false
      this.$refs.input.blur()
      this.$emit("update:model-value", null)
      this.$emit("close")
    }
  }
}
</script>

<style lang="scss" scoped>
.search-icon {
  height: 16px !important;
  width: 16px !important;
}
.search-field-container {
  display: flex;
  flex-grow: 1;

  &.mobile {
    .search-field :deep(.v-input__control .v-field) {
      min-height: 32px;
      max-height: 32px;
      display: flex;
      align-items: center;
    }
  }

  .search-field {
    color: var(--top-bar-text-40);
    background-color: var(--top-bar-text-5);
    border-radius: 5px;

    :deep(.v-field) {
      background-color: var(--top-bar-text-5) !important;
    }

    :deep(.v-input__control) {
      min-height: 0;

      .v-field {
        min-height: 40px;
        max-height: 40px;
        border: 1px solid transparent !important;
        padding: 0 8px;

        &.v-field--focused {
          border-color: var(--top-bar-tint) !important;
        }
      }
    }
  }
}
</style>
